
import React, { useState, useEffect, useRef, useContext } from 'react';

//Auth
import { AppContext, AppProvider } from "./Components/Auth/contexts/AppContext";
import { ProgressProvider } from './Components/common/ProgressContext';
import { ErrorProvider } from './Components/common/ErrorContext';

import AuthContainer from "./Components/Auth/AuthContainer"
import AuthLogout from "./Components/Auth/AuthLogout"
import LoginPage from "./Components/Auth/LoginPage"

import {
  Switch,
  Route,
  Link,
  useLocation,
  useHistory,
  useParams
} from "react-router-dom";
import { BrowserRouter } from 'react-router-dom'
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';


//Theme generated from color picker and subsequent tool:
//https://material.io/resources/color/#!/?view.left=0&view.right=0&primary.color=01579B&secondary.color=ECEFF1
//https://react-theming.github.io/create-mui-theme/
//Theme sets default Material UI for all elements. We also use theme in our new classes and overrides in FlexCss"

//CSS Styles
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { ThemeProvider } from '@emotion/react';

//import { useTheme, ThemeProvider, StyledEngineProvider } from '@mui/material/styles'; 
import deluxetheme1 from "./ui/theme/index";
import flexstyles from './css/FlexCss';
import useCustomStyles from './ui/useCustomStyles';
import useClasses from './ui/useClasses';
import { useMediaQuery, useTheme, IconButton } from "@mui/material";

//Main Menu
import MainMenu from './features/mainmenu/MainMenu';



import 'typeface-roboto';
import deluxelogo from './Components/images/deluxe.png';
import Box from '@mui/material/Box';
//import Grid from '@mui/material/Grid';
import Grid from '@mui/material/GridLegacy';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import Drawer from '@mui/material/Drawer';
import TextField from '@mui/material/TextField';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';
import Collapse from '@mui/material/Collapse';

import Dialog from '@mui/material/Dialog';
import ListItemButton from '@mui/material/ListItemButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
 
import MainPage from "./Components/MainPage"; //Legacy Dashboard
import BoilerplateFlexiGrid from "./Components/Boilerplate/BoilerplateFlexiGrid"; 
import BoilerplateTable from "./Components/Boilerplate/BoilerplateTable";
import BoilerplateKeyValues from "./Components/Boilerplate/BoilerplateKeyValues";
import BoilerplateFlexiItem from "./Components/Boilerplate/BoilerplateFlexiItem";
import BoilerplateTableTest from "./Components/Boilerplate/BoilerplateTableTest";
import ChartBuilder from "./Components/Boilerplate/ChartBuilder";
import Toybox from "./Components/Boilerplate/Toybox";


//Login
import Login from "./Components/Login";

//Admin Section
import UserTable from "./Components/Admin/UserTable";
import UsersFlexiGrid from "./Components/Admin/UsersFlexiGrid"; 
import UserView from "./Components/Admin/UserView";
import ClientAccess from "./Components/Admin/ClientAccess";
import Locations from "./Components/Admin/Locations";
import IntegrationsTable from "./Components/Admin/IntegrationsTable";
import ReportDownloads from "./Components/Admin/ReportDownloads";
import LogTable from "./Components/Admin/LogTable";
import ItemPrograms from "./Components/Admin/ItemPrograms";
import Maintenance from "./Components/Admin/Maintenance";


//Products
import Products from "./Components/Products/Products"; //Legacy
//import ProductsTable from "./Components/Products/ProductsTable";
import ProductsFlexiGrid from "./Components/Products/ProductsFlexiGrid";
import ProductTypesTable from "./Components/Products/ProductTypesTable";
import ProductView from "./Components/Products/ProductView";
import SkusTable from "./Components/Products/SkusTable";
import SkuIntegrationsTable from "./Components/Products/SkuIntegrationsTable";
import EbayAuth from "./Components/Products/EbayAuth";
import ComponentsTable from "./Components/Products/ComponentsTable";
import ComponentView from "./Components/Products/ComponentView";
import ComponentTypesTable from "./Components/Products/ComponentTypesTable";

//Hardware Agent
import SpecsTable from "./Components/Specs/SpecsTable";
import SpecAliasTable from "./Components/Specs/SpecAliasTable";
import BatteryTest from "./Components/Specs/BatteryTest";
import HDDSpecs from "./Components/Specs/HDDSpecs";

//Inventory
//import Items from "./Components/Inventory/Items"; //Legacy - Killed 9/10/2024
import Checkin from "./Components/Inventory/Checkin"; //Legacy
import Checkout from "./Components/Inventory/Checkout"; //Legacy
import InventoryManager from "./Components/Inventory/InventoryManager";
import Item from "./Components/Inventory/Item";
import Purchasing from "./Components/Inventory/Purchasing"; //deprecate
import Purchase from "./Components/Inventory/Purchase"; //deprecate
import PurchaseFlexiItem from "./Components/Inventory/PurchaseFlexiItem"; //deprecate
import PurchasesFlexiGrid from "./Components/Inventory/PurchasesFlexiGrid";
import RowMonitor from "./Components/Inventory/RowMonitor";
import Costing from "./Components/Inventory/Costing";
import ListingsTable from "./Components/Inventory/ListingsTable";
import PartsFlexiGrid from "./Components/Parts/PartsFlexiGrid";
import PartFlexiItem from "./Components/Parts/PartFlexiItem";
import PartPurchasesFlexiGrid from "./Components/Parts/PartPurchasesFlexiGrid";
import PartPurchaseFlexiItem from "./Components/Parts/PartPurchaseFlexiItem";


//Orders
import OrdersTable from "./Components/Orders/OrdersTable";
import OrdersFlexiGrid from "./Components/Orders/OrdersFlexiGrid";
import OrderInspection from "./Components/Orders/OrderInspection";
import Orders from "./Components/Orders/Orders"; //Legacy - Soon to be new React
import OrdersView from "./Components/Orders/OrdersView";
import OrderProcessing from "./Components/Orders/OrderProcessing"; //Legacy
//import OrderManifests from "./Components/Orders/OrderManifests"; //Legacy
import OrderViewLegacy from "./Components/Orders/OrderViewLegacy"; //Front for legacy

//Reports
import Reports from "./Components/Reports/Reports"; //Legacy
import SalesGraph from "./Components/Reports/SalesGraph"; //Legacy
import TopProducts from "./Components/Reports/TopProducts"; //Legacy
import ProductPerformance from "./Components/Reports/ProductPerformance"; //Legacy

//Calculator
import PriceCalculator from "./Components/common/PriceCalculator"; //Legacy

//Label Maker
import LabelMaker from './Components/common/LabelMaker';

//Documents
import DocumentsTable from './Components/Documents/DocumentsTable';
import DocumentView from './Components/Documents/DocumentView';

//Listing Builder (Templates)
import ListingTemplatesTable from './Components/Products/ListingTemplatesTable';
import ListingBuilder from './Components/Products/ListingBuilder';

//Dev Section
import LogViewer from "./Components/Admin/LogViewer"; 
import EbayRequestsFlexiGrid from "./Components/Purchasing/EbayRequestsFlexiGrid";  
import EbayRequestView from "./Components/Purchasing/EbayRequestView";  
import LenovoPartsFlexiGrid from "./Components/Purchasing/LenovoPartsFlexiGrid";  


import MenuIcon from '@mui/icons-material/Menu';


//Test of React Redux
import { Counter } from './features/counter/Counter';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});



//Config
let appbase = process.env.REACT_APP_BASE;


// Move FullScreenDialog out — but it needs `isWide`... actually it doesn't, only open/close state
function FullScreenDialog({ open, onOpen, onClose }) {
	return (
		<React.Fragment>
			<IconButton color="inherit" edge="start" onClick={onOpen} sx={{ mr: 2 }}>
				<MenuIcon />
			</IconButton>
			<Dialog fullScreen open={open} onClose={onClose} slots={{ transition: Transition }}>
				<AppBar sx={{ position: 'relative' }}>
					<Toolbar>
						<Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
							Menu
						</Typography>
						<IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
							<CloseIcon />
						</IconButton>
					</Toolbar>
				</AppBar>
				<MainMenu type="mobile" onClose={onClose} />
			</Dialog>
		</React.Fragment>
	);
}

// Move LoggedInContent out — pass in everything it needs as props
function LoggedInContent({ state, updateState, localstate, classes, isWide, history }) {
	const appContext = useContext(AppContext);
	const { authStatus, checklogin, userUserName, logout, userRole, setCurrentMenu, currentmenu, userPerms, userTZ } = appContext;
 
	// Mobile hamburger dialog open/close state lives here now, as real
	// component state, so it survives re-renders correctly on its own.
	const [dialogOpen, setDialogOpen] = useState(false);
 
	const LogUserOut = () => {
		//Sync localstate! Is within lexical scope?
		localstate.loginstate = false;
		updateState(localstate);
		logout();
	}
 
	//Expanding Menus (open/close) - Uses context
	const handleMenuClick = (menuitem) => {
		if (menuitem === currentmenu) {
			setCurrentMenu("");
		} else {
			setCurrentMenu(menuitem);
		}
	};
 
	//The following will update our parent App (this), BEFORE we navigate to the following page. Avoids attempting to load the new page's database items twice.
	const handleClickMenuItem = (menuitem) => {
		localstate.navigate = true;
		localstate.navigateto = menuitem;
		localstate.selectedmenu = menuitem;
		updateState(localstate);
	}
 
	function ToggleMenus() {
		localstate.hidemenus = !localstate.hidemenus;
		updateState(localstate);
	}
 
	return (
		<>
			<MuiThemeProvider theme={deluxetheme1}>
				<ThemeProvider theme={deluxetheme1}>{/* Emotion Theme Provider for styled components */}
					<div className={classes.root}>
						<CssBaseline />
						{(!state.hidemenus) &&
							<AppBar elevation={1} position="fixed" className={classes.appBar} style={(appbase.indexOf('localhost')>-1) ? {backgroundColor:"red", borderBottom:"1px solid #003C6B"} : {backgroundColor:"#004983", borderBottom:"1px solid #003C6B"}}>
								<Toolbar style={{ minHeight: '26px' }}>
									<Grid
										justifyContent="space-between" // Add it here :)
										container
										gap={1}
										columnGap={1}
									>
										<Grid item>
											<a target="_blank" href="/">
												<img src={deluxelogo} alt="Flex System" style={{ width: "125px", paddingTop: "5px" }} />
											</a>
										</Grid>
 
										<Grid item sx={{display:isWide ? "" : "none"}}>
											<div style={{ padding: "6px 12px 0px 2px", display: "inline-block" }}>
												Logged in as {userUserName}
											</div>
 
											<Button color="inherit" onClick={LogUserOut} style={{ margin: "4px 2px 0px 2px", border: "1px solid #FFF", padding: "1px 5px", verticalAlign: "top" }}>
												Logout
											</Button>
										</Grid>
 
										<Grid sx={{display:isWide ? "none" : ""}}>
											<FullScreenDialog
												open={dialogOpen}
												onOpen={() => setDialogOpen(true)}
												onClose={() => setDialogOpen(false)}
											/>
										</Grid>
 
									</Grid>
								</Toolbar>
							</AppBar>
						}
 
						{/* ####     LOGGED-IN DRAWER MENU    #### */}
						{/* Hide drawer menu for Inventory Manager */}
						{(!state.hidemenus) &&
							<Box sx={{ displayPrint: 'none', display:isWide ? "" : "none"}}>
								<MainMenu type="desktop" />
							</Box>
						}
 
						{/* ####     CONTENT AREA    #### */}
						<main style={{ overflow: "auto", width:"100%" }}>
							<div className={state.hidemenus ? classes.contentwithoutmenus : classes.contentwithmenus} id="flexcontentcontainer">
								{(state.hidemenus) &&
									<div style={{ height: "0px", textAlign: "right", position: "relative" }}>
										{/* See if we can put in a small menubox here */}
										<div className={classes.showmenubtn} style={{ height: "20px", right: "0px", zIndex: "5000" }}>
											<a onClick={ToggleMenus} className={classes.hoverunit}>Show Menus</a>
										</div>
									</div>
								}
 
								<Switch>
									<Route exact path="/" render={() => <ErrorProvider><MainPage /></ErrorProvider>} />
 
									{/* Orders */}
									<Route path="/orderstable" render={(props) => <ErrorProvider><OrdersTable /></ErrorProvider>} />
									<Route path="/ordersflexigrid" render={(props) => <ErrorProvider><OrdersFlexiGrid /></ErrorProvider>} />
									<Route path="/orderinspection" render={(props) => <ErrorProvider><OrderInspection /></ErrorProvider>} />
									<Route path="/order/:id" render={(props) => <ErrorProvider><OrdersView isChild={false} viewmode="details" /></ErrorProvider>} />
									{/* Old Route: */}<Route path="/orders" render={(props) => <ErrorProvider><Orders /></ErrorProvider>} />
 
									<Route path="/order/:id" render={(props) => <ErrorProvider><OrdersTable /></ErrorProvider>} />
									<Route path="/orderprocessing" render={(props) => <ErrorProvider><OrderProcessing /></ErrorProvider>} />
 
									{/* Legacy Order View */}
									<Route path="/orderview/:orderid" render={(props) => <ErrorProvider><OrderViewLegacy updateState={updateState} /></ErrorProvider>} />
 
									{/* Products */}
									<Route path="/products" render={(props) => <ErrorProvider><ProductsFlexiGrid /></ErrorProvider>} />
									<Route path="/productsflexigrid" render={(props) => <ErrorProvider><ProductsFlexiGrid /></ErrorProvider>} />
									<Route path="/product/:id" render={(props) => <ErrorProvider><ProductView /></ErrorProvider>} />
									<Route path="/productslegacy" render={(props) => <ErrorProvider><Products /></ErrorProvider>} />
									<Route path="/producttypes" render={(props) => <ErrorProvider><ProductTypesTable/></ErrorProvider>} />
									<Route path="/components" render={(props) => <ErrorProvider><ComponentsTable /></ErrorProvider>} />
									<Route path="/component/:id" render={(props) => <ErrorProvider><ComponentView /></ErrorProvider>} />
									<Route path="/componenttypes" render={(props) => <ErrorProvider><ComponentTypesTable /></ErrorProvider>} />
									<Route path="/skus" render={(props) => <ErrorProvider><SkusTable /></ErrorProvider>} />
									<Route path="/skuintegrations/ebayauth" render={(props) => <ErrorProvider><EbayAuth /></ErrorProvider>} />
									<Route path="/skuintegrations" render={(props) => <ErrorProvider><SkuIntegrationsTable /></ErrorProvider>} />
									<Route path="/listingtemplates/:id" render={(props) => <ErrorProvider><ListingBuilder /></ErrorProvider>} />
									<Route path="/listingtemplates" render={(props) => <ErrorProvider><ListingTemplatesTable /></ErrorProvider>} />
 
									{/* Hardware Agent */}
									<Route path="/specs" render={(props) => <ErrorProvider><SpecsTable /></ErrorProvider>} />
									<Route path="/specalias" render={(props) => <ErrorProvider><SpecAliasTable /></ErrorProvider>} />
									<Route path="/batterytest" render={(props) => <ErrorProvider><BatteryTest /></ErrorProvider>} />
									<Route path="/hddspecs" render={(props) => <ErrorProvider><HDDSpecs /></ErrorProvider>} />
 
									{/* Reports */}
									<Route path="/reports" render={(props) => <ErrorProvider><Reports /></ErrorProvider>} />
									<Route path="/salesgraph" render={(props) => <ErrorProvider><SalesGraph /></ErrorProvider>} />
									<Route path="/topproducts" render={(props) => <ErrorProvider><TopProducts /></ErrorProvider>} />
									<Route path="/productperformance" render={(props) => <ErrorProvider><ProductPerformance /></ErrorProvider>} />
 
									{/* Label Maker */}
									<Route path="/labelmaker" render={(props) => <ErrorProvider><LabelMaker /></ErrorProvider>} />
 
									{/* Documents */}
									<Route path="/documents" render={(props) => <ErrorProvider><DocumentsTable /></ErrorProvider>} />
									<Route path="/document/:id" render={(props) => <ErrorProvider><DocumentView /></ErrorProvider>} />
 
									{/*Admin Settings*/}
									<Route path="/users" render={(props) => <ErrorProvider><UsersFlexiGrid /></ErrorProvider>} />
									<Route path="/user/:id" render={(props) => <ErrorProvider><UserView /></ErrorProvider>} />
									<Route path="/clientaccess" render={(props) => <ErrorProvider><ClientAccess theme={deluxetheme1} /></ErrorProvider>} />
									<Route path="/integrations" render={(props) => <ErrorProvider><IntegrationsTable /></ErrorProvider>} />
									<Route path="/logs" render={(props) => <ErrorProvider><LogTable /></ErrorProvider>} />
									<Route path="/itemprograms" render={(props) => <ErrorProvider><ItemPrograms /></ErrorProvider>} />
									<Route path="/maintenance" render={(props) => <ErrorProvider><Maintenance /></ErrorProvider>} />
 
									{/*Inventory Items*/}
									<Route path="/item/:id" render={(props) => <ErrorProvider><Item /></ErrorProvider>} />
									<Route path="/checkin" render={(props) => <ErrorProvider><Checkin /></ErrorProvider>} />
									<Route path="/checkout" render={(props) => <ErrorProvider><Checkout /></ErrorProvider>} />
									<Route path="/inventorymanager" render={(props) => <ErrorProvider><InventoryManager /></ErrorProvider>} />
									<Route path="/purchasing/:id" render={(props) => <ErrorProvider><Purchase /></ErrorProvider>} />
									<Route path="/purchase/:id" render={(props) => <ErrorProvider><PurchaseFlexiItem /></ErrorProvider>} />
									<Route path="/purchasing" render={(props) => <ErrorProvider><Purchasing /></ErrorProvider>} />
									<Route path="/purchasemanager" render={(props) => <ErrorProvider><PurchasesFlexiGrid /></ErrorProvider>} />
									<Route path="/rowmonitor" render={(props) => <ErrorProvider><RowMonitor /></ErrorProvider>} />
									<Route path="/pricing" render={(props) => <ErrorProvider><Costing /></ErrorProvider>} />
									<Route path="/listings" render={(props) => <ErrorProvider><ListingsTable /></ErrorProvider>} />
									<Route path="/pricecalculator" render={(props) => <ErrorProvider><PriceCalculator /></ErrorProvider>} />
									<Route path="/parts" render={(props) => <ErrorProvider><PartsFlexiGrid /></ErrorProvider>} />
									<Route path="/part/:id" render={(props) => <ErrorProvider><PartFlexiItem /></ErrorProvider>} />
									<Route path="/partpurchases" render={(props) => <ErrorProvider><PartPurchasesFlexiGrid /></ErrorProvider>} />
									<Route path="/partpurchase/:id" render={(props) => <ErrorProvider><PartPurchaseFlexiItem /></ErrorProvider>} />
 
									{/* Marty's special dev section*/}
									<Route path="/boilerplateflexigrid" render={(props) => <ErrorProvider><ProgressProvider><BoilerplateFlexiGrid /></ProgressProvider></ErrorProvider>} />
									<Route path="/boilerplatetable" render={(props) => <ErrorProvider><ProgressProvider><BoilerplateTable /></ProgressProvider></ErrorProvider>} />
									<Route path="/boilerplatekeyvalues/:id" render={(props) => <ErrorProvider><BoilerplateKeyValues /></ErrorProvider>} />
									<Route path="/boilerplateflexiitem/:id" render={(props) => <ErrorProvider><BoilerplateFlexiItem /></ErrorProvider>} />
									<Route path="/boilerplatetabletest" render={(props) => <ErrorProvider><BoilerplateTableTest /></ErrorProvider>} />
									<Route path="/chartbuilder" render={(props) => <ErrorProvider><ChartBuilder /></ErrorProvider>} />
									<Route path="/toybox" render={(props) => <ErrorProvider><Toybox /></ErrorProvider>} />
									<Route path="/logviewer" render={(props) => <ErrorProvider><LogViewer /></ErrorProvider>} />
									<Route path="/ebayrequests/:id" render={(props) => <ErrorProvider><EbayRequestView /></ErrorProvider>} />
									<Route path="/ebayrequests" render={(props) => <ErrorProvider><EbayRequestsFlexiGrid /></ErrorProvider>} />
									<Route path="/lenovoparts" render={(props) => <ErrorProvider><LenovoPartsFlexiGrid /></ErrorProvider>} />
									<Route path="/maintenance" render={(props) => <ErrorProvider><Maintenance /></ErrorProvider>} />
 
									{/* Serve static files directly */}
									<Route path="/storage" component={() => window.location = window.location.href} />
 
								</Switch>
 
							</div>
						</main>
					</div>
 
				</ThemeProvider>
			</MuiThemeProvider>
 
		</>
	)
}

// Move AppContainer out too
function AppContainer({ state, updateState, localstate, classes, isWide, history, deluxetheme1 }) {
	const appContext = useContext(AppContext);
	const { authStatus, logout, checklogin, appStarted } = appContext;

	useEffect(() => {
		checklogin();
	}, []);

	return (
		<>
			{(authStatus === "logged_in" && appStarted) &&
				<LoggedInContent 
				state={state}
					updateState={updateState}
					localstate={localstate}
					classes={classes}
					isWide={isWide}
					history={history}
					deluxetheme1={deluxetheme1} />
			}
			{(authStatus !== "logged_in" && appStarted) &&
				<LoginPage state={state} updateState={updateState}/>
			}
		</>
	)
}

//CSS
//const styles = (deluxetheme1) => (flexstyles);


const App = () => {
	/* CSS and Media Queries */
	//const theme = useTheme();
	//const classes = useCustomStyles(styles, theme);
	const classes = useClasses(flexstyles);
	//const isPrintView = useMediaQuery("print");
	let history = useHistory();
	const theme = useTheme();
	// Only show menu if wider than 600px (sm breakpoint)
	const isWide = useMediaQuery(theme.breakpoints.up('md'));




	//Get current location
	let location = useLocation();
	const [state, setState] = useState({
		loginstate: false,
		userrole: '',
		username:'',
		appstart: true,
		authchecked:false,
		timeout: 0,
		selectedmenu:"",
		sessioninterval:false,
		navigate:false,
		navigateto:"/",
		hidemenus:false,
		viewid:uuidv4(),
		//Bool for view t/f
		//inventorymanager:invmgr,
		//Try! Orders Table State
		orderstablestate:{}
		
	})

	const updateState = (stateObject) => {
		console.log("updateState");
		setState(stateObject)
	}

	//Clone State for mutability
	let localstate = Object.assign({}, state);

	axios.defaults.withCredentials = true;
	var requestconfig = {
		withCredentials: true,
		withXSRFToken: true,
		crossDomain: true,
		mode: 'no-cors'
	}


	function ToggleMenus() {
		localstate.hidemenus=!localstate.hidemenus;
		updateState(localstate);
	}

	const preventDefault = (event) => event.preventDefault();


	const [open, setOpen] = React.useState(false);
	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
	  

	// function FullScreenDialog() {
		
	  
	// 	return (
	// 		<React.Fragment>
	// 			<IconButton
	// 				color="inherit"
	// 				edge="start"
	// 				onClick={handleClickOpen}
	// 				sx={{ mr: 2 }}
	// 			>
	// 				<MenuIcon />
	// 			</IconButton>

	// 			{/* This handles the mobile menu itself */}
	// 			<Dialog
	// 				fullScreen
	// 				open={open}
	// 				onClose={handleClose}
	// 				slots={{
	// 					transition: Transition,
	// 				}}
	// 			>
	// 				<AppBar sx={{ position: 'relative' }}>
	// 					<Toolbar>
	// 						<Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
	// 							Menu
	// 						</Typography>
	// 						<IconButton
	// 							edge="start"
	// 							color="inherit"
	// 							onClick={handleClose}
	// 							aria-label="close"
	// 						>
	// 							<CloseIcon />
	// 						</IconButton>
	// 					</Toolbar>
	// 				</AppBar>
	// 				<MainMenu type="mobile" onClose={handleClose} />
	// 			</Dialog>
	// 		</React.Fragment>
	// 	);
	// }

	//Causes this to run once, otherwise endless loop
	useEffect(() => {
		if (state.appstart) {
			localstate.selectedmenu = location.pathname;
		} 
		if (state.navigate){
			localstate.navigate = false;
			history.push(localstate.navigateto);
			updateState(localstate);
		}
	})



// 	const LoggedInContent = () => {
// 		const appContext = useContext(AppContext);
// 		const { authStatus, checklogin, userUserName, logout, userRole, setCurrentMenu, currentmenu, userPerms, userTZ } = appContext;


// 		const LogUserOut = () => {
// 			//Sync localstate! Is within lexical scope?
// 			localstate.loginstate = false;
// 			updateState(localstate);
// 			logout();
// 		}

// 		//Expanding Menus (open/close) - Uses context
// 		const handleMenuClick = (menuitem) => {
// 			if (menuitem === currentmenu) {
// 				setCurrentMenu("");
// 			} else {
// 				setCurrentMenu(menuitem);
// 			}
// 		};


// 		//The following will update our parent App (this), BEFORE we navigate to the following page. Avoids attempting to load the new page's database items twice.
// 		const handleClickMenuItem = (menuitem) => {
// 			localstate.navigate = true;
// 			localstate.navigateto = menuitem;
// 			localstate.selectedmenu = menuitem;
// 			updateState(localstate);
// 		}

// 		return (
// 			<>
// 					<MuiThemeProvider theme={deluxetheme1}>
// 						<ThemeProvider theme={deluxetheme1}>{/* Emotion Theme Provider for styled components */} 
// 					<div className={classes.root}>
// 						<CssBaseline />
// 						{(!state.hidemenus) &&
// 							<AppBar elevation={1} position="fixed" className={classes.appBar} style={(appbase.indexOf('localhost')>-1) ? {backgroundColor:"red", borderBottom:"1px solid #003C6B"} : {backgroundColor:"#004983", borderBottom:"1px solid #003C6B"}}>
// 								<Toolbar style={{ minHeight: '26px' }}>
// 									<Grid
// 										justifyContent="space-between" // Add it here :)
// 										container
// 										gap={1}
// 										columnGap={1}
// 									>
// 										<Grid item>
// 											<a target="_blank" href="/">
// 												<img src={deluxelogo} alt="Flex System" style={{ width: "125px", paddingTop: "5px" }} />
// 											</a>
// 										</Grid>

// 										<Grid item sx={{display:isWide ? "" : "none"}}>
// 											<div style={{ padding: "6px 12px 0px 2px", display: "inline-block" }}>
// 												Logged in as {userUserName}
// 											</div>

// 											<Button color="inherit" onClick={LogUserOut} style={{ margin: "4px 2px 0px 2px", border: "1px solid #FFF", padding: "1px 5px", verticalAlign: "top" }}>
// 												Logout
// 											</Button>
// {/* 
// 											{(!state.hidemenus) &&
// 												<Button color="inherit" onClick={ToggleMenus} style={{ margin: "4px 0px 2px 8px", border: "1px solid #FFF", padding: "2px 5px", verticalAlign: "top" }}>
// 													Hide Menus
// 												</Button>
// 											} */}
// 										</Grid>

// 										<Grid sx={{display:isWide ? "none" : ""}}>
// 											<FullScreenDialog />
// 										</Grid>

// 									</Grid>
// 								</Toolbar>
// 							</AppBar>
// 						}



// 						{/* ####     LOGGED-IN DRAWER MENU    #### */}
// 						{/* Hide drawer menu for Inventory Manager */}
// 						{(!state.hidemenus) &&
// 							<Box sx={{ displayPrint: 'none', display:isWide ? "" : "none"}}>
// 								<MainMenu type="desktop" />
// 							</Box>
// 						}


// 						{/* ####     CONTENT AREA    #### */}
// 						<main style={{ overflow: "auto", width:"100%" }}>
// 							<div className={state.hidemenus ? classes.contentwithoutmenus : classes.contentwithmenus} id="flexcontentcontainer">
// 								{(state.hidemenus) &&
// 									<div style={{ height: "0px", textAlign: "right", position: "relative" }}>
// 										{/* See if we can put in a small menubox here */}
// 										<div className={classes.showmenubtn} style={{ height: "20px", right: "0px", zIndex: "5000" }}>
// 											<a onClick={ToggleMenus} className={classes.hoverunit}>Show Menus</a>
// 										</div>
// 									</div>
// 								}

								
// 									<Switch>
// 										<Route exact path="/" render={() => <ErrorProvider><MainPage /></ErrorProvider>} />

// 										{/* Orders */}
// 										{/* New Route: */}
// 										<Route path="/orderstable" render={(props) => <ErrorProvider><OrdersTable /></ErrorProvider>} />
// 										<Route path="/ordersflexigrid" render={(props) => <ErrorProvider><OrdersFlexiGrid /></ErrorProvider>} />
// 										<Route path="/orderinspection" render={(props) => <ErrorProvider><OrderInspection /></ErrorProvider>} />
// 										<Route path="/order/:id" render={(props) => <ErrorProvider><OrdersView isChild={false} viewmode="details" /></ErrorProvider>} />
// 										{/* Old Route: */}<Route path="/orders" render={(props) => <ErrorProvider><Orders /></ErrorProvider>} />

						
// 										{/* <Route path="/ordersview" render={(props) => <ErrorProvider><OrdersView mode="edit" /></ErrorProvider>} /> */}
// 										<Route path="/order/:id" render={(props) => <ErrorProvider><OrdersTable /></ErrorProvider>} />
// 										{/* <Route path="/orderinvoices" render={(props) => <ErrorProvider><OrdersView mode="invoices" updateState={updateState} /></ErrorProvider>} />
// 										<Route path="/orderworksheets" render={(props) => <ErrorProvider><OrdersView mode="worksheets" updateState={updateState} /></ErrorProvider>} /> */}
// 										<Route path="/orderprocessing" render={(props) => <ErrorProvider><OrderProcessing /></ErrorProvider>} />
// 										{/* <Route path="/ordermanifests" render={(props) => <ErrorProvider><OrderManifests /></ErrorProvider>} /> */}

// 										{/* Legacy Order View */}
// 										<Route path="/orderview/:orderid" render={(props) => <ErrorProvider><OrderViewLegacy updateState={updateState} /></ErrorProvider>} />

// 										{/* Products */}
// 										<Route path="/products" render={(props) => <ErrorProvider><ProductsFlexiGrid /></ErrorProvider>} />
// 										<Route path="/productsflexigrid" render={(props) => <ErrorProvider><ProductsFlexiGrid /></ErrorProvider>} />
// 										<Route path="/product/:id" render={(props) => <ErrorProvider><ProductView /></ErrorProvider>} />
// 										<Route path="/productslegacy" render={(props) => <ErrorProvider><Products /></ErrorProvider>} />
// 										<Route path="/producttypes" render={(props) => <ErrorProvider><ProductTypesTable/></ErrorProvider>} />
// 										<Route path="/components" render={(props) => <ErrorProvider><ComponentsTable /></ErrorProvider>} />
// 										<Route path="/component/:id" render={(props) => <ErrorProvider><ComponentView /></ErrorProvider>} />
// 										<Route path="/componenttypes" render={(props) => <ErrorProvider><ComponentTypesTable /></ErrorProvider>} />
// 										<Route path="/skus" render={(props) => <ErrorProvider><SkusTable /></ErrorProvider>} />
// 										<Route path="/skuintegrations/ebayauth" render={(props) => <ErrorProvider><EbayAuth /></ErrorProvider>} />
// 										<Route path="/skuintegrations" render={(props) => <ErrorProvider><SkuIntegrationsTable /></ErrorProvider>} />
// 										<Route path="/listingtemplates/:id" render={(props) => <ErrorProvider><ListingBuilder /></ErrorProvider>} />
// 										<Route path="/listingtemplates" render={(props) => <ErrorProvider><ListingTemplatesTable /></ErrorProvider>} />
										

// 										{/* Hardware Agent */}
// 										<Route path="/specs" render={(props) => <ErrorProvider><SpecsTable /></ErrorProvider>} />
// 										<Route path="/specalias" render={(props) => <ErrorProvider><SpecAliasTable /></ErrorProvider>} />
// 										<Route path="/batterytest" render={(props) => <ErrorProvider><BatteryTest /></ErrorProvider>} />
// 										<Route path="/hddspecs" render={(props) => <ErrorProvider><HDDSpecs /></ErrorProvider>} />

// 										{/* Reports */}
// 										<Route path="/reports" render={(props) => <ErrorProvider><Reports /></ErrorProvider>} />
// 										<Route path="/salesgraph" render={(props) => <ErrorProvider><SalesGraph /></ErrorProvider>} />
// 										<Route path="/topproducts" render={(props) => <ErrorProvider><TopProducts /></ErrorProvider>} />
// 										<Route path="/productperformance" render={(props) => <ErrorProvider><ProductPerformance /></ErrorProvider>} />

// 										{/* Label Maker */}
// 										<Route path="/labelmaker" render={(props) => <ErrorProvider><LabelMaker /></ErrorProvider>} />

// 										{/* Documents */}
// 										<Route path="/documents" render={(props) => <ErrorProvider><DocumentsTable /></ErrorProvider>} />
// 										<Route path="/document/:id" render={(props) => <ErrorProvider><DocumentView /></ErrorProvider>} />

// 										{/*Admin Settings*/}
// 										{/* <Route path="/users" render={(props) => <ErrorProvider><UserTable /></ErrorProvider>} /> */}
// 										<Route path="/users" render={(props) => <ErrorProvider><UsersFlexiGrid /></ErrorProvider>} />
// 										<Route path="/user/:id" render={(props) => <ErrorProvider><UserView /></ErrorProvider>} />
// 										<Route path="/clientaccess" render={(props) => <ErrorProvider><ClientAccess theme={deluxetheme1} /></ErrorProvider>} />
// 										<Route path="/integrations" render={(props) => <ErrorProvider><IntegrationsTable /></ErrorProvider>} />
// 										<Route path="/logs" render={(props) => <ErrorProvider><LogTable /></ErrorProvider>} />
// 										<Route path="/itemprograms" render={(props) => <ErrorProvider><ItemPrograms /></ErrorProvider>} />
// 										<Route path="/maintenance" render={(props) => <ErrorProvider><Maintenance /></ErrorProvider>} />

// 										{/*Inventory Items*/}
// 										{/* <Route path="/items" render={(props) => <ErrorProvider><Items /></ErrorProvider>} /> */}
// 										<Route path="/item/:id" render={(props) => <ErrorProvider><Item /></ErrorProvider>} />
// 										<Route path="/checkin" render={(props) => <ErrorProvider><Checkin /></ErrorProvider>} />
// 										<Route path="/checkout" render={(props) => <ErrorProvider><Checkout /></ErrorProvider>} />
// 										<Route path="/inventorymanager" render={(props) => <ErrorProvider><InventoryManager /></ErrorProvider>} />
// 										<Route path="/purchasing/:id" render={(props) => <ErrorProvider><Purchase /></ErrorProvider>} />
// 										<Route path="/purchase/:id" render={(props) => <ErrorProvider><PurchaseFlexiItem /></ErrorProvider>} />
// 										<Route path="/purchasing" render={(props) => <ErrorProvider><Purchasing /></ErrorProvider>} />
// 										<Route path="/purchasemanager" render={(props) => <ErrorProvider><PurchasesFlexiGrid /></ErrorProvider>} />
// 										<Route path="/rowmonitor" render={(props) => <ErrorProvider><RowMonitor /></ErrorProvider>} />
// 										<Route path="/pricing" render={(props) => <ErrorProvider><Costing /></ErrorProvider>} />
// 										<Route path="/listings" render={(props) => <ErrorProvider><ListingsTable /></ErrorProvider>} />
// 										<Route path="/pricecalculator" render={(props) => <ErrorProvider><PriceCalculator /></ErrorProvider>} />


// 										{/* Marty's special dev section*/}
// 										<Route path="/boilerplateflexigrid" render={(props) => <ErrorProvider><ProgressProvider><BoilerplateFlexiGrid /></ProgressProvider></ErrorProvider>} />
// 										<Route path="/boilerplatetable" render={(props) => <ErrorProvider><ProgressProvider><BoilerplateTable /></ProgressProvider></ErrorProvider>} />
// 										<Route path="/boilerplatekeyvalues/:id" render={(props) => <ErrorProvider><BoilerplateKeyValues /></ErrorProvider>} />
// 										<Route path="/boilerplateflexiitem/:id" render={(props) => <ErrorProvider><BoilerplateFlexiItem /></ErrorProvider>} />
// 										<Route path="/boilerplatetabletest" render={(props) => <ErrorProvider><BoilerplateTableTest /></ErrorProvider>} />
// 										<Route path="/chartbuilder" render={(props) => <ErrorProvider><ChartBuilder /></ErrorProvider>} />
// 										<Route path="/toybox" render={(props) => <ErrorProvider><Toybox /></ErrorProvider>} />
// 										<Route path="/logviewer" render={(props) => <ErrorProvider><LogViewer /></ErrorProvider>} />
// 										<Route path="/ebayrequests/:id" render={(props) => <ErrorProvider><EbayRequestView /></ErrorProvider>} />
// 										<Route path="/ebayrequests" render={(props) => <ErrorProvider><EbayRequestsFlexiGrid /></ErrorProvider>} />
// 										<Route path="/lenovoparts" render={(props) => <ErrorProvider><LenovoPartsFlexiGrid /></ErrorProvider>} />
// 										<Route path="/maintenance" render={(props) => <ErrorProvider><Maintenance /></ErrorProvider>} />
										


// 										  {/* Serve static files directly */}
//      									<Route path="/storage" component={() => window.location = window.location.href} />

// 									</Switch>
								
// 							</div>
// 						</main>
// 					</div>

// 				</ThemeProvider>
// 					</MuiThemeProvider>
			
// 			</>
// 		)

// 	}

	//One container to manage view via shared App Context
	// const AppContainer = () => {
	// 	const appContext = useContext(AppContext);
	// 	const { authStatus, logout, checklogin, appStarted } = appContext;
	// 	useEffect(()=>{
	// 		//How often does this run.
	// 		//console.log("UseEffect we just made;");
	// 		checklogin();
	// 	},[]);

	// 	return (
	// 		<>

	// 			{/* Otimistic. If the server doesn't recognize their token, it will redirect the user to login anyway. */}
	// 			{(authStatus==="logged_in" && appStarted) &&
	// 				<LoggedInContent />
	// 			}

	// 			{/* We don't want to flash the LoginPage if we haven't given ourselves an opportunity to log in automatically. */}
	// 			{(authStatus!=="logged_in" && appStarted) &&
	// 				<LoginPage state={state} updateState={updateState}/>
	// 			}

	// 			{/*
	// 			<div>
	// 				AppStart: {String(appStarted)}<br></br>
	// 				AuthStatus: {String(authStatus)}<br></br>
	// 				AuthChecked: {String(state.authchecked)}<br></br>
	// 				LoginState: {String(state.loginstate)}<br></br>
	// 			</div>
	// 			*/}
				
	// 		</>
	// 	)
	// }



	//Render
	return (
		<StyledEngineProvider injectFirst>
			<AppProvider>
			<AppContainer
					state={state}
					updateState={updateState}
					localstate={localstate}
					classes={classes}
					isWide={isWide}
					history={history}
					deluxetheme1={theme}
				/>
			</AppProvider>
		</StyledEngineProvider>
	);
}

  
export default App;